(ns toolkit.modal
  (:require #?(:cljs [reagent.core :as r])
            [stylo.core :refer [c]]
            [toolkit.button]
            [zf.form]
            [zf :as zf]))

(def document-scroll-position (atom 0))

(zf/defx show-modal
  [{db :db} content-id]
  (println "show modal ")
  #?(:cljs (let [class-list (.. js/document -body -classList)]
             (when-not (.contains class-list "overflow-hidden")
               (reset! document-scroll-position (.. js/document -body -scrollTop))
               (.add class-list "overflow-hidden"))))
  {:db (-> db
           (zf.form/set-state {:zf/root [::db] :zf/path []} nil)
           (zf.form/set-state {:zf/root [::db] :zf/path [content-id :shown]} true))})


(zf/defx hide-modal [{db :db}]
  #?(:cljs (let [class-list (.. js/document -body -classList)]
             (when (.contains class-list "overflow-hidden")
               (set! (.. js/document -body -scrollTop) @document-scroll-position)
               (.remove class-list "overflow-hidden"))))
  {:db (zf.form/set-state db {:zf/root [::db] :zf/path []} nil)})


(zf/defs modal-state
  [db [_ content-id]]
  (zf.form/state db {:zf/root [::db] :zf/path [content-id :shown]}))

(def custom-scrollbar (c [:pseudo "::-webkit-scrollbar" {:background "none"}
                          [:w "8px"]
                          :overflow-hidden]
                         [:pseudo "::-webkit-scrollbar-thumb" {:background "rgba(0, 0, 0, 0.1)"}
                          [:rounded :full]]
                         [:pseudo "::-webkit-scrollbar-track" {:background "none"}
                          [:w "10px"]]))

(defn modal [content-id title annotation content]
  (let [shown (zf/subscribe [::modal-state content-id])]
    (when @shown
      [:div {:class (c :fixed [:top "0"] [:left "0"] [:right "0"] [:bottom "0"]
                       {:background "rgba(0,0,0,0.3)"
                        :backdrop-filter "blur(11.5px)"}
                       [:z 2] :overflow-hidden
                       :flex :flex-col :justify-center :items-center)
             :on-click (fn [e]
                         (.preventDefault e)
                         (.stopPropagation e)
                         (zf/dispatch [::hide-modal]))}
       [:div {:class [(c [:h-max "90%"]
                         [:w-max "90%"]
                         [:bg :white] [:rounded 16]
                         :overflow-hidden)
                      custom-scrollbar]
              :on-click (fn [e] (.stopPropagation e))}
        [:div {:class (c :flex :justify-between :items-center [:px 6] [:pt 4] [:py 4] :border-b)}
         [:span {:class (c :text-xl [:text :tgray-900] :font-semibold :tracking-wide)} title]

         [:div {:class (c [:rounded :full] [:py 2] [:px 3] [:text :sdc-gray-fg]
                          :leading-none
                          [:border 2 :sdc-gray-fg] [:bg :white]
                          :cursor-pointer
                          :transition-all [:duration 150] :ease-in-out
                          [:hover [:border 2 :sdc-purple-2] [:text :sdc-purple-2]]
                          [:focus [:border 2 :sdc-purple-2] [:text :sdc-purple-2]])
                :on-click #(zf/dispatch [::hide-modal])}
          [:i.fas.fa-close {:class (c :text-xl)}]]]
        #_[toolkit.button/button {:type "text"
                                  :class (c :absolute [:top 2] [:right 1])
                                  :on-click #(zf/dispatch [::hide-modal])} [:i.fas.fa-xmark]]
        [:div {:class [(c :overflow-scroll
                          [:h "calc(100% - 72.5px)"])
                       custom-scrollbar]}
         content]]])))


(defn dialog [content-id title content]
  (when @(zf/subscribe [::modal-state content-id])
    [:dialog {:ref      #(when % (.showModal %))
              :on-close #(zf/dispatch [::hide-modal])
              :class    ["fixed rounded-xl z-20 backdrop:bg-black/50 backdrop:backdrop-blur-md overflow-hidden flex flex-col"]}
     [:div {:class "flex justify-between items-center px-6 py-4 border-b"}
      [:span {:class "text-xl font-semibold"} title]
      [:button {:class "top-2 right-2 rounded-full w-8 h-8 text-xl focus:outline-none text-gray-400 hover:bg-white active:bg-indigo-700 active:text-white"
                :on-click #(zf/dispatch [::hide-modal])}
       [:i.fal.fa-times]]]
     [:div {:class "px-6 py-6 overflow-auto"}
      content]]))
